"use client";
import { FC, useEffect, useState } from "react";
import Input from "./components/Input";
import Tabs from "./components/Tabs";
import { TABS_DATA } from "./mock";
import FaqItem from "@/components/common/FAQItem";
import { ITabDataItem } from "@/types/types";
import EmailBlock from "./components/EmailBlock";
import { getDataFromStrapi } from "@/strapi/api";

type Props = {
	strapiData?: any;
};

const FaqScreen: FC<Props> = ({ strapiData: initialStrapiData = {} }) => {
	const [strapiData, setStrapiData] = useState(initialStrapiData);

	const strapiTabs = (strapiData?.data ?? [])
		.slice()
		.sort((a: any, b: any) => a.id - b.id)
		.map((el: any) => el.attributes);
	const tabsSource = strapiTabs.length ? strapiTabs : TABS_DATA;
	const tabsNames = tabsSource.map((el: any) => el.tabName);
	const [currentTab, setCurrentTab] = useState(tabsNames[0] ?? "");
	useEffect(() => {
		if (tabsNames.length && !tabsNames.includes(currentTab)) {
			setCurrentTab(tabsNames[0] ?? "");
		}
	}, [tabsNames, currentTab]);
	const tabsData: ITabDataItem[] =
		tabsSource.find((el: any) => el.tabName === currentTab)?.data ?? [];

	useEffect(() => {
		let isActive = true;
		const load = async () => {
			const data = await getDataFromStrapi("/api/faqs?populate=*");
			if (!isActive) {
				return;
			}
			setStrapiData(data);
		};
		load();
		return () => {
			isActive = false;
		};
	}, []);
	return (
		<div className='flex flex-col bg-main'>
			<p className='text-center font-bold text-[72px] mt-[100px] max-desktop:mt-[39px] max-desktop:text-[40px]'>
				{`FAQ’s`}
			</p>

			<p className='text-[23px] max-desktop:text-[16px] text-white pb-[83px] max-desktop:pb-[29px]  text-center opacity-85'>
				Choose a category to quickly find the help you need
			</p>

			<Tabs tabs={tabsNames} currentTab={currentTab} setTab={setCurrentTab} />

			<p
				className='text-[50px] text-center leading-[66px] max-desktop:leading-[37px] font-bold pt-[118px] mb-[51px] max-desktop:text-[28px] max-desktop:pt-[74px] max-desktop:mb-[33px]'
				id='faq'>
				{currentTab}
			</p>

			<div className='flex flex-col gap-y-[8px] max-desktop:gap-y-[4px] px-[80px] max-desktop:px-[33px] max-tablet:px-[16px]'>
				{tabsData.map((el, index) => (
					<FaqItem title={el.title} text={el.text} key={index} />
				))}
			</div>
			<div className='flex flex-col px-[16px]'>
				<p className='font-bold text-center text-[50px] mt-[154px] max-desktop:text-[28px] max-desktop:mt-[81px]'>
					You still have question?
				</p>
				<p className='text-[23px] w-[821px] text-white mx-auto text-center opacity-85 max-desktop:text-[17px] max-desktop:w-[575px] max-tablet:w-full'>
					If you can’t find answer to your question in our FAQ, you can always
					contact us. We will answer to you shortly!
				</p>

				<EmailBlock />
			</div>
		</div>
	);
};

export default FaqScreen;
